import { createStore, combineReducers } from 'redux'
import rootReducer from './reducers/rootReducer'

const store = createStore(
  combineReducers(rootReducer),
  process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
export default store
